export const color = {
    white :'white',
    black:'black',
    primary:'#16618a',
    gray:'#5b5b5b',
    light_gray:'#ced4da',
    medium_gray:'#afa9ad',
    v_light_gray:'#f5f3f4',
    dark_primary:'#006227',
    inactive_tab:'#D7D7CF',
    profileContainerBg:'#f3f3f3',
    linkHover:'#f7f7f7',
    blue:'#218cc4'
}